import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LeadService} from '../../shared/services/lead.service';
import {CounsellorService} from '../../shared/services/counsellor.service';
import {AlertService} from '../../shared/services/alert.service';
import {StorageService} from '../../shared/services/storage.service';

@Component({
    selector: 'app-leads',
    templateUrl: './leads.component.html',
    styleUrls: ['./leads.component.scss']
})
export class LeadsComponent implements OnInit {
    showSearch = false;
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    leads = [];
    counsellors: any = [];
    modalType: any;
    selectedLead: any;
    assignCounsellorForm: FormGroup;
    statusForm: FormGroup;
    user: any;
    statuses = ['NEW', 'ASSIGNED', 'CONTACTED', 'FOLLOW_UP', 'CONVERTED', 'CLOSED'];

    constructor(private router: Router,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private leadService: LeadService,
                private counsellorService: CounsellorService,
                private alertService: AlertService) {
        this.user = StorageService.getItem('self');
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'name': [''],
            'contact': [''],
            'email': ['']
        });
        this.assignCounsellorForm = this.fb.group({
            'assigned_to': ['', Validators.required]
        });
        this.statusForm = this.fb.group({
            'status': ['', Validators.required]
        });
        this.get();
        this.getCounsellors();
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.leads = [];
        this.leadService.get(params).subscribe(data => {
            if (data && data['data'] && data['data'].length > 0) {
                this.leads = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.leads = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    getCounsellors() {
        this.counsellorService.get({'page': -1, 'user_type': 'COUNSELLOR'}).subscribe(data => {
            this.counsellors = (data && data['data']) ? data['data'] : [];
        }, error => {
        });
    }

    search() {
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'contact': (this.searchForm.value && this.searchForm.value.contact) ? this.searchForm.value.contact : '',
            'email': (this.searchForm.value && this.searchForm.value.email) ? this.searchForm.value.email : ''
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        this.search();
    }

    viewDetail(lead) {
        this.router.navigate(['ask-expert-professional', lead.id]);
    }

    viewCounsellorsModal(content, lead) {
        this.selectedLead = lead;
        this.modalType = 'COUNSELLOR_ASSIGN';
        this.assignCounsellorForm.patchValue({
            'assigned_to': lead?.assigned_to || ''
        });
        this.modalService.open(content, {size: 'lg'});
    }

    assignCounsellor() {
        this.submitted = true;
        if (!this.assignCounsellorForm.valid) {
            return;
        }
        const params = {
            'assigned_to': this.assignCounsellorForm.value.assigned_to
        };
        this.submitting = true;
        this.leadService.assignCounsellor(this.selectedLead.id, params).subscribe(data => {
            this.submitting = false;
            this.submitted = false;
            this.modalService.dismissAll('');
            this.get();
        }, error => {
            this.submitting = false;
            this.submitted = false;
        });
    }

    changeStatusModal(content, lead) {
        this.selectedLead = lead;
        this.modalType = 'STATUS';
        this.statusForm.patchValue({
            'status': lead?.status || ''
        });
        this.modalService.open(content, {size: 'lg'});
    }

    changeStatus() {
        this.submitted = true;
        if (!this.statusForm.valid) {
            return;
        }
        const params = {
            'name': this.selectedLead.name,
            'email': this.selectedLead.email,
            'contact': this.selectedLead.contact,
            'course_id': this.selectedLead.course_id,
            'university_id': this.selectedLead.university_id,
            'message': this.selectedLead.message,
            'status': this.statusForm.value.status
        };
        this.submitting = true;
        this.leadService.update(this.selectedLead.id, params).subscribe(data => {
            this.submitting = false;
            this.submitted = false;
            this.modalService.dismissAll('');
            this.get();
        }, error => {
            this.submitting = false;
            this.submitted = false;
        });
    }
}
